interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
}

function SectionHeading({ eyebrow, title, desc, align = "left" }: SectionHeadingProps) {
  const alignCls = align === "center" ? "items-center text-center" : "items-start text-left";
  return (
    <div className={`flex flex-col gap-3 ${alignCls}`}>
      {eyebrow && (
        <span className="inline-flex items-center gap-2 rounded-full bg-secondary-500/10 px-3 py-1 text-xs font-medium tracking-wide text-secondary-300">
          <span className="h-1 w-1 rounded-full bg-secondary-400"></span>
          {eyebrow}
        </span>
      )}
      <h2 className="font-serif text-3xl font-black leading-tight tracking-tight text-foreground-50 md:text-4xl">
        {title}
      </h2>
      {desc && (
        <p className={`max-w-2xl text-base leading-relaxed text-foreground-400 ${align === "center" ? "mx-auto" : ""}`}>
          {desc}
        </p>
      )}
    </div>
  );
}

export default SectionHeading;